import React from "react";
import { Navigate } from "react-router-dom";
import Spinner from "../../layout/Spinner";
import { useParticipantAuth } from "../../../contexts/participant-auth.context";

type ParticipantRouteProps = {
    isPublic?: boolean;
    layout?: React.ComponentType<{ children: React.ReactNode }>;
    component: React.ComponentType<Record<string, unknown>>;
};

/**
 * Route guard component for participant routes with authentication checks
 * Migrated to React Router v6 pattern
 */
export const ParticipantRoute: React.FC<ParticipantRouteProps> = ({
    isPublic = false,
    layout: Layout,
    component: Component,
}) => {
    const { isAuthenticated, isAuthenticating } = useParticipantAuth();

    // Handle authentication check for protected routes
    if (!isAuthenticated && !isPublic) {
        if (isAuthenticating) {
            return <Spinner />;
        }
        return <Navigate to="/sign-in/" replace />;
    }

    // Render the component with optional layout wrapper
    return (
        <>
            {Layout ? (
                <Layout>
                    <Component />
                </Layout>
            ) : (
                <Component />
            )}
        </>
    );
};
